import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { envelopeOpenDollarBenefit, handHoldingDollarBenefit, moneyBillTransferBenefit, promotionBenefit, refreshBenefit, } from '@ibk/shared-assets';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { ApiProductStatus, AppDomain } from '@ibk/shared-types';
import { contaPjTranslations } from '../../translations';
import { AccountOpeningSteps } from './AccountOpeningSteps';
import { ContaPJPageLayout } from './ContaPJPageLayout';
import styles from './ContaPJPromo.module.css';
const resolveVariant = (status) => status === ApiProductStatus.ACTIVATING ? 'activating' : 'promo';
const buildModalSteps = (context, t) => {
    if (context === AppDomain.EMPRESA) {
        return [
            {
                title: t('modal.steps.empresa.step1.title'),
                description: t('modal.steps.empresa.step1.description'),
                state: 'current',
            },
            {
                title: t('modal.steps.empresa.step2.title'),
                description: t('modal.steps.empresa.step2.description'),
                state: 'pending',
            },
            {
                title: t('modal.steps.empresa.step3.title'),
                description: t('modal.steps.empresa.step3.description'),
                state: 'pending',
            },
            {
                title: t('modal.steps.empresa.step4.title'),
                description: t('modal.steps.empresa.step4.description'),
                state: 'pending',
            },
        ];
    }
    return [
        {
            title: t('modal.steps.step1.title'),
            description: t('modal.steps.step1.description'),
            state: 'current',
        },
        {
            title: t('modal.steps.step2.title'),
            description: t('modal.steps.step2.description'),
            state: 'pending',
        },
    ];
};
function AccountOpeningModal({ isOpen, onClose, context }) {
    const { t } = useTranslation();
    if (!isOpen)
        return null;
    const steps = buildModalSteps(context, t);
    return (_jsx("div", { className: styles.modalOverlay, children: _jsxs("div", { className: styles.modal, children: [_jsxs("div", { className: styles.modalHeader, children: [_jsx("h2", { className: styles.modalTitle, children: t('modal.title') }), _jsx("button", { className: styles.closeButton, onClick: onClose, "aria-label": t('modal.closeLabel'), children: "\u00D7" })] }), _jsx("div", { className: styles.modalContent, children: _jsx(AccountOpeningSteps, { steps: steps, dataTestId: 'conta-pj-promo-modal-steps' }) })] }) }));
}
function ActivatingCard() {
    const { t } = useTranslation();
    const steps = [
        {
            title: t('modal.steps.step1.title'),
            description: t('modal.steps.step1.description'),
            state: 'done',
        },
        {
            title: t('modal.steps.step2.title'),
            description: t('modal.steps.step2.description'),
            state: 'current',
        },
    ];
    return (_jsxs("div", { className: styles.card, "data-testid": 'conta-pj-promo-activating', children: [_jsx("h2", { className: styles.cardTitle, children: t('activating.cardTitle') }), _jsx(AccountOpeningSteps, { steps: steps, dataTestId: 'conta-pj-promo-activating-steps' })] }));
}
function BenefitsCard({ context }) {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: styles.card, children: [_jsx("h2", { className: styles.cardTitle, children: t('promo.cardTitle') }), _jsxs("div", { className: styles.benefitsList, children: [_jsxs("div", { className: styles.benefit, children: [_jsx("div", { className: styles.benefitIcon, children: _jsx("img", { src: envelopeOpenDollarBenefit, alt: t('promo.benefits.pixAlt') }) }), _jsx("p", { className: styles.benefitText, children: t('promo.benefits.pix') })] }), _jsxs("div", { className: styles.benefit, children: [_jsx("div", { className: styles.benefitIcon, children: _jsx("img", { src: promotionBenefit, alt: t('promo.benefits.exclusiveAlt') }) }), _jsx("p", { className: styles.benefitText, children: t('promo.benefits.exclusive') })] }), _jsxs("div", { className: styles.benefit, children: [_jsx("div", { className: styles.benefitIcon, children: _jsx("img", { src: moneyBillTransferBenefit, alt: t('promo.benefits.freeAlt') }) }), _jsx("p", { className: styles.benefitText, children: t('promo.benefits.free') })] }), _jsxs("div", { className: styles.benefit, children: [_jsx("div", { className: styles.benefitIcon, children: _jsx("img", { src: refreshBenefit, alt: t('promo.benefits.routinesAlt') }) }), _jsx("p", { className: styles.benefitText, children: t('promo.benefits.routines') })] }), _jsxs("div", { className: styles.benefit, children: [_jsx("div", { className: styles.benefitIcon, children: _jsx("img", { src: handHoldingDollarBenefit, alt: t('promo.benefits.collectionsAlt') }) }), _jsx("p", { className: styles.benefitText, dangerouslySetInnerHTML: { __html: t('promo.benefits.collections') } })] })] }), _jsx("button", { className: styles.ctaButton, onClick: () => setIsModalOpen(true), children: t('promo.ctaButton') })] }), _jsx(AccountOpeningModal, { isOpen: isModalOpen, onClose: () => setIsModalOpen(false), context: context })] }));
}
export function ContaPJPromoContent({ context = AppDomain.ESCRITORIO, status }) {
    const { t } = useTranslation();
    const variant = resolveVariant(status);
    return (_jsx(ContaPJPageLayout, { context: context, dataTestId: 'conta-pj-promo', title: t('promo.title'), subtitle: t('promo.subtitle'), bannerAlt: t('promo.bannerAlt'), children: variant === 'activating' ? _jsx(ActivatingCard, {}) : _jsx(BenefitsCard, { context: context }) }));
}
export function ContaPJPromo({ context = AppDomain.ESCRITORIO, status }) {
    return (_jsx(TranslationProvider, { translations: contaPjTranslations, defaultLanguage: 'pt-BR', children: _jsx(ContaPJPromoContent, { context: context, status: status }) }));
}
